import { getActiveRoundsCategoryKey } from "../utils/categoryRounds";
import type { ReactNode } from "react";
import AppSelect from "../../../shared/components/AppSelect";
import Button from "../../../shared/components/Button";
import { siteTexts } from "../../../shared/i18n/siteTexts";
import type { TournamentRegistrationCategoryItem } from "../utils/tournamentCategories";
import "./AdminCategoryRoundsPanel.css";

type Props = {
  categories: TournamentRegistrationCategoryItem[];
  activeCategoryKey: string;
  onSelectCategory: (key: string) => void;
  onEditCategory: (key: string) => void;
  onGenerate: () => void;
  canGenerate: boolean;
  generating: boolean;
  hasRounds: boolean;
  showGenerate: boolean;
  readOnly: boolean;
  onSaveResults?: () => void;
  canSaveResults?: boolean;
  children: ReactNode;
};

export default function AdminCategoryRoundsPanel({
  categories, activeCategoryKey, onSelectCategory, onEditCategory, onGenerate,
  canGenerate, generating, hasRounds, showGenerate, readOnly, children,
  onSaveResults, canSaveResults = false,
}: Props) {
  const t = siteTexts.admin;
  const selectedKey = getActiveRoundsCategoryKey(categories, activeCategoryKey);
  return <div className="admin-category-rounds-panel">
    <div className="admin-category-rounds-toolbar">
      <label className="field">
        <span>{t.tournamentCategoryEditor.fallbackCategory}</span>
        <AppSelect value={selectedKey} onChange={event => onSelectCategory(event.target.value)} disabled={generating}>
          {categories.map(category => <option key={category.categoryKey} value={category.categoryKey}>{category.categoryName}</option>)}
        </AppSelect>
      </label>
      {!readOnly && <div className="admin-category-rounds-actions">
        {hasRounds && onSaveResults && <Button type="button" variant="primary" disabled={!canSaveResults || generating} onClick={onSaveResults}>
          {generating ? t.historyList.saving : 'Salvar resultados'}
        </Button>}
        <Button type="button" variant="pill" disabled={!selectedKey || generating} onClick={() => onEditCategory(selectedKey)}>
          {t.tournamentCategoryEditor.editCategory}
        </Button>
        {showGenerate && <Button type="button" variant="primary" disabled={!canGenerate || generating} onClick={onGenerate}>
          {generating ? t.historyList.saving : hasRounds ? t.createChallengePage.operations.regenerateRounds : siteTexts.challengeEngine.labels.generateRounds}
        </Button>}
      </div>}
    </div>
    {children}
  </div>;
}
